import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import bgImage from "../../assets/hero3.png";
import { API_BASE_URL } from "../../utils/adminApi";
import "./AdminAuth.css";

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (loading) return;
    setError("");

    try {
      setLoading(true);
      const res = await axios.post(
        `${API_BASE_URL}/api/admin/login`,
        { email, password }
      );

      sessionStorage.setItem("token", res.data.token);
      sessionStorage.setItem("adminUser", JSON.stringify(res.data.admin));

      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="auth-wrapper"
      style={{
        background: `linear-gradient(rgba(15,23,42,0.85), rgba(15,23,42,0.85)), url(${bgImage})`,
      }}
    >
      <div className="auth-card">
        <div className="brand-logo">
      <h2 className="logo-text">
     Appliance Repair <span>Admin Panel</span>
</h2>
        </div>

        {/* <h3 className="subtitle">Admin Portal</h3> */}
        <p className="subtitle">Secure access for repair management</p>

        {/* EMAIL */}
        <div className="auth-form-group">
          <input
            type="email"
            placeholder="Admin Email"
            className="auth-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        {/* PASSWORD */}
        <div className="auth-form-group">
          <div className="auth-input-wrap">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="auth-input auth-input-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {error && (
          <p className="error-text">{error}</p>
        )}

        <button
          className="auth-btn"
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Signing In..." : "Log In"}
        </button>
      </div>
    </div>
  );
}

export default AdminLogin;